import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import Drilldown from 'highcharts/modules/drilldown';
import Sunburst from 'highcharts/modules/sunburst';
import SolidGauge from 'highcharts/modules/solid-gauge';
import Exporting from 'highcharts/modules/exporting';
import OfflineExporting from 'highcharts/modules/offline-exporting';
import GroupedCategories from 'highcharts-grouped-categories';
import Gantt from 'highcharts/modules/gantt';
import PatternFill from 'highcharts/modules/pattern-fill';

window.Highcharts = Highcharts;

HighchartsMore(Highcharts);
Drilldown(Highcharts);
Sunburst(Highcharts);
SolidGauge(Highcharts);
Exporting(Highcharts);
OfflineExporting(Highcharts);
GroupedCategories(Highcharts);
Gantt(Highcharts);
PatternFill(Highcharts);

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
